export default function validateInputStringCoordinates(input) {
  const regex = /^-?\d{1,2}\.\d{5,}, ?-?\d{1,3}\.\d{5,19}$/
  return regex.test(input)
}
